<template>
  <div
    :class="[
      `auth`,
      `auth--${slug}`,
      `group`,
      `group--first-last`,
    ]"
  >
    <tag
      v-if="titleSet !== null"
      :is="modal ? `h2` : `h1`"
      :class="[
        `mt0`,
        modal ? `h3` : `h2`,
        {
          'mt0': modal,
        }
      ]"
    >{{ titleSet }}</tag>
    <p
      v-if="copySet"
      class="p tc"
      v-html="successCopy && status.success ? successCopy : copySet"
    />
    <slot name="top-link" />
    <p v-if="slug === `login`" class="p small">Haven't got an account? <module-link link="register-patient">Sign Up</module-link></p>
    <div
      v-show="!successCopy || (successCopy && !status.success)"
    >
      <module-form
        :class="[
          `auth__form`,
          `auth__form--${slug}`,
        ]"

        :form-id="formId"
        :fields="fields[slug]"

        :action="requestAction"
        :success="success"
        :fail="fail"
        :submit="submitSet"

        button-size="m"
        button="primary"
      >
        <div slot="before-submit" class="form__before-button">
          <slot name="before-submit" />
        </div>
      </module-form>
    </div>


    <p v-if="hasFooter" class="auth__footer small tc">
      <slot name="link" />
    </p>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import { _forms, login, registerPatient, registerDentist, reset, confirm } from 'models/auth';

// Modules
import ModuleForm from 'modules/Form';
import ModuleLogo from 'modules/Logo';
import ModuleLink from 'modules/Link';

// Export
export default {
  name: `ui-auth-login`,

  // Components
  components: {
    ModuleForm,
    ModuleLogo,
    ModuleLink,
  },

  // Props
  props: {
    title: String,
    copy: String,
    successCopy: String,
    modal: Boolean,
    slug: {
      type: String,
      required: true,
    },
    submit: String,
    success: {
      type: Function,
      default() {
        return () => {}; // eslint-disable-line no-empty-function
      },
    },
    fail: {
      type: Function,
      default() {
        return () => {}; // eslint-disable-line no-empty-function
      },
    },
  },

  // Data
  data() {
    return {
      fields: {
        login,
        registerPatient,
        registerDentist,
        reset,
        confirm,
      },
      things: {
        registerDentistFields: this.registerDentistFields,
      },
    };
  },
  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
      `getStatus`,
    ]),
    ...mapGetters(`review`, [
      `reviewNomenclature`,
      `reviewNomenclatureBySlug`,
      `reviewNomenclatureBySlugAndId`,
      `reviewRequests`,
      `reviewRequestsById`,
    ]),
    formId() {
      return `${this.slug}${this.modal ? `-modal` : ``}`;
    },
    model() {
      return this.getModel(this.formId);
    },
    status() {
      return this.getStatus(this.formId);
    },
    action() {
      return _forms.actions[this.slug];
    },
    submitSet() {
      return this.submit || _forms.submit[this.slug] || ``;
    },
    titleSet() {
      if (this.isPasswordSet) return `Set Password`;

      if (typeof this.title !== `undefined`) {
        return this.title || null;
      }
      return _forms.title[this.slug] || null;
    },
    copySet() {
      if (this.isPasswordSet) return `Welcome to VeriTooth! A VeriTooth account has already been created for you using your email address, please create a password below to complete your account set up`;

      if (typeof this.copy !== `undefined`) {
        return this.copy || null;
      }
      return _forms.copy[this.slug] || null;
    },
    hasFooter() {
      return !!this.$slots.link || this.slug === `login`;
    },
    isPasswordSet() {
      return this.$route.name === `set-password`;
    },
  },

  // Methods
  methods: {
    ...mapActions(`review`, [
      `getNomenclature`,
    ]),
    requestAction() {
      return this.$store.dispatch(`auth/${this.action}`, this.model);
    },
  },
  created() {
    if(this.slug !== `registerDentist`) {
      return;
    }

    this.getNomenclature()
      .then(() => {
        this.fields.registerDentist.specialty.items = this.reviewNomenclatureBySlug(`specialties`);
      });
  },
};
</script>



// WEBPACK FOOTER //
// Auth.vue?78b0467c